import type { ActivityModule } from '../../core/activity';
import { mountAlgebraPlus } from './ui';
import levelsData from './levels.json';
import './style.css';

export const algebraPlus: ActivityModule = {
  id: 'algebra_plus',
  title: 'Adição',
  description: 'Pratique a soma de dois números com tabuadas progressivas (1 ao 10) e finalize com somas livres até 100.',
  ageMin: 6,
  ageMax: 10,
  difficulty: 3,
  iconPath: 'assets/gcompris-AGPL/algebra_plus/icon.svg',
  category: 'aritmetica',
  totalLevels: levelsData.levels.length,
  mount: mountAlgebraPlus,
};
